// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__3WCD9","label":"Radio_label__17ow8","checkMark":"Radio_checkMark__2GIwI","disabled":"Radio_disabled__1h6RK"};